import type { Lang } from "./language";

type AdminContent = {
  title: string;
  lead: string;
  denied: string;
  back: string;
  tabs: {
    applications: string;
    groups: string;
    templates: string;
    coupons: string;
    publications: string;
  };
  publications: {
    heading: string;
    editHeading: string;
    lead: string;
    title: string;
    titlePlaceholder: string;
    journal: string;
    journalPlaceholder: string;
    year: string;
    indexed: string;
    quartile: string;
    description: string;
    descriptionPlaceholder: string;
    authors: string;
    addAuthor: string;
    authorName: string;
    authorCountry: string;
    noAuthors: string;
    doi: string;
    doiPlaceholder: string;
    link: string;
    linkPlaceholder: string;
    openLink: string;
    create: string;
    saveChanges: string;
    cancel: string;
    edit: string;
    delete: string;
    created: string;
    updated: string;
    deleted: string;
    confirmDelete: string;
    empty: string;
    invalid: string;
    invalidYear: string;
    yes: string;
    no: string;
  };
  coupons: {
    heading: string;
    lead: string;
    code: string;
    codePlaceholder: string;
    description: string;
    descriptionPlaceholder: string;
    type: string;
    typePercent: string;
    typeAmount: string;
    percentOff: string;
    amountOff: string;
    currency: string;
    pathway: string;
    anyPathway: string;
    startsAt: string;
    expiresAt: string;
    maxRedemptions: string;
    maxRedemptionsHint: string;
    unlimited: string;
    create: string;
    created: string;
    empty: string;
    active: string;
    inactive: string;
    activate: string;
    deactivate: string;
    delete: string;
    deleted: string;
    confirmDelete: string;
    usage: string;
    window: string;
    noWindow: string;
    expired: string;
    scheduled: string;
    redemptions: string;
    redemptionsEmpty: string;
    viewRedemptions: string;
    hideRedemptions: string;
    participant: string;
    discountApplied: string;
    invalidCode: string;
    invalidDiscount: string;
  };

  apps: {
    heading: string;
    empty: string;
    filterAll: string;
    status: string;
    reviewerNotes: string;
    reviewerNotesPlaceholder: string;
    saveStatus: string;
    saved: string;
    history: string;
    historyEmpty: string;
    addComment: string;
    commentPlaceholder: string;
    sendComment: string;
    commentSaved: string;
    group: string;
    noGroup: string;
    assign: string;
    assigned: string;
    unassign: string;
    fee: string;
    acceptOnlyGroup: string;
    groupFull: string;
    noGroupForPathway: string;
  };
  groups: {
    heading: string;
    lead: string;
    name: string;
    namePlaceholder: string;
    pathway: string;
    startsOn: string;
    capacity: string;
    notes: string;
    notesPlaceholder: string;
    create: string;
    created: string;
    empty: string;
    members: string;
    seats: string;
    archive: string;
    activate: string;
    active: string;
    archived: string;
  };
  email: {
    title: string;
    openGroup: string;
    openIndividual: string;
    demoBadge: string;
    demoNote: string;
    to: string;
    subject: string;
    body: string;
    sessionLink: string;
    send: string;
    cancel: string;
    demoSent: string;
    missingFields: string;
    noRecipients: string;
    missingEmails: string;
    logTitle: string;
    logEmpty: string;
    defaultSubjectGroup: string;
    defaultSubjectIndividual: string;
    defaultBody: string;
    template: string;
    templateLang: string;
    preview: string;
    variablesHint: string;
  };
  template: {
    heading: string;
    lead: string;
    nameEs: string;
    nameEn: string;
    subjectEs: string;
    subjectEn: string;
    bodyEs: string;
    bodyEn: string;
    buttonEs: string;
    buttonEn: string;
    signatureEs: string;
    signatureEn: string;
    image: string;
    imageHint: string;
    save: string;
    saved: string;
    preview: string;
    previewLang: string;
    variables: string;
    variablesHint: string;
    empty: string;
  };
};


const es: AdminContent = {
  title: "Dirección Académica",
  lead: "Revisa solicitudes, habilita pagos y organiza los grupos del programa.",
  denied: "Esta sección es exclusiva de la Dirección Académica STM.",
  back: "Ir a mi portal",
  tabs: {
    applications: "Solicitudes",
    groups: "Grupos",
    templates: "Plantilla de correo",
    coupons: "Cupones",
    publications: "Publicaciones",
  },
  publications: {
    heading: "Nueva publicación",
    editHeading: "Editar publicación",
    lead: "Registra las publicaciones del programa: revista, año, indexación, cuartil, autores, DOI y liga externa.",
    title: "Título",
    titlePlaceholder: "Título del artículo",
    journal: "Nombre de la revista",
    journalPlaceholder: "Ej. Cureus",
    year: "Año",
    indexed: "Revista indexada",
    quartile: "Pertenece a alguna Q",
    description: "Descripción",
    descriptionPlaceholder: "Resumen breve del artículo…",
    authors: "Autores y países",
    addAuthor: "Agregar autor",
    authorName: "Nombre del autor",
    authorCountry: "País",
    noAuthors: "Sin autores registrados.",
    doi: "DOI",
    doiPlaceholder: "10.xxxx/...",
    link: "Liga externa",
    linkPlaceholder: "https://...",
    openLink: "Abrir liga",
    create: "Crear publicación",
    saveChanges: "Guardar cambios",
    cancel: "Cancelar",
    edit: "Editar",
    delete: "Eliminar",
    created: "Publicación creada.",
    updated: "Publicación actualizada.",
    deleted: "Publicación eliminada.",
    confirmDelete: "¿Eliminar esta publicación?",
    empty: "Aún no hay publicaciones registradas.",
    invalid: "Captura el título y el nombre de la revista.",
    invalidYear: "Ingresa un año válido.",
    yes: "Sí",
    no: "No",
  },
  coupons: {
    heading: "Cupones de descuento",
    lead: "Crea cupones con vigencia por fechas y límite de usos, y revisa quién los ha redimido.",
    code: "Código del cupón",
    codePlaceholder: "Ej. STM2026",
    description: "Descripción interna",
    descriptionPlaceholder: "Campaña, alianza, beca…",
    type: "Tipo de descuento",
    typePercent: "Porcentaje",
    typeAmount: "Monto fijo",
    percentOff: "Porcentaje de descuento (%)",
    amountOff: "Monto de descuento",
    currency: "Moneda",
    pathway: "Aplica a la ruta",
    anyPathway: "Cualquier ruta",
    startsAt: "Vigente desde",
    expiresAt: "Vigente hasta",
    maxRedemptions: "Número máximo de usos",
    maxRedemptionsHint: "Déjalo vacío para usos ilimitados.",
    unlimited: "Ilimitado",
    create: "Crear cupón",
    created: "Cupón creado.",
    empty: "Aún no hay cupones creados.",
    active: "Activo",
    inactive: "Inactivo",
    activate: "Activar",
    deactivate: "Desactivar",
    delete: "Eliminar",
    deleted: "Cupón eliminado.",
    confirmDelete: "¿Eliminar este cupón y su historial de redenciones?",
    usage: "Usos",
    window: "Vigencia",
    noWindow: "Sin límite de fechas",
    expired: "Vencido",
    scheduled: "Programado",
    redemptions: "Redenciones",
    redemptionsEmpty: "Nadie ha redimido este cupón todavía.",
    viewRedemptions: "Ver redenciones",
    hideRedemptions: "Ocultar redenciones",
    participant: "Participante",
    discountApplied: "Descuento aplicado",
    invalidCode: "Usa de 3 a 40 caracteres: letras, números y guiones.",
    invalidDiscount: "Ingresa un valor de descuento válido.",
  },

  apps: {
    heading: "Solicitudes recibidas",
    empty: "No hay solicitudes por el momento.",
    filterAll: "Todas",
    status: "Estado de la solicitud",
    reviewerNotes: "Notas para el participante",
    reviewerNotesPlaceholder: "Observaciones visibles para el aspirante…",
    saveStatus: "Guardar estado",
    saved: "Solicitud actualizada.",
    history: "Historial",
    historyEmpty: "Sin movimientos registrados.",
    addComment: "Comentario interno / seguimiento",
    commentPlaceholder: "Escribe un comentario para el historial…",
    sendComment: "Agregar comentario",
    commentSaved: "Comentario agregado.",
    group: "Grupo asignado",
    noGroup: "Sin grupo",
    assign: "Asignar",
    assigned: "Asignación actualizada.",
    unassign: "Quitar del grupo",
    fee: "Participación",
    acceptOnlyGroup:
      "Guarda el estado como aceptada o pagada para poder asignar la solicitud a un grupo.",
    groupFull: "Este grupo ya alcanzó su cupo máximo.",
    noGroupForPathway: "No hay grupos activos para esta ruta. Crea uno en la pestaña Grupos.",
  },
  groups: {
    heading: "Grupos del programa",
    lead: "Crea grupos por ruta y asigna a los participantes aceptados.",
    name: "Nombre del grupo",
    namePlaceholder: "Ej. Grupo Básico Otoño 2026",
    pathway: "Ruta",
    startsOn: "Fecha de inicio",
    capacity: "Cupo",
    notes: "Notas",
    notesPlaceholder: "Mentor asignado, horario de sesiones…",
    create: "Crear grupo",
    created: "Grupo creado.",
    empty: "Aún no hay grupos creados.",
    members: "Integrantes",
    seats: "lugares",
    archive: "Archivar",
    activate: "Reactivar",
    active: "Activo",
    archived: "Archivado",
  },
  email: {
    title: "Correo del programa",
    openGroup: "Enviar correo al grupo",
    openIndividual: "Enviar correo",
    demoBadge: "Demo",
    demoNote:
      "Modo demostración: el correo se registra en la plataforma pero aún no sale al buzón de los participantes. Se activará al configurar el dominio remitente de STM.",
    to: "Para",
    subject: "Asunto",
    body: "Mensaje",
    sessionLink: "Enlace de la sesión",
    send: "Registrar envío (demo)",
    cancel: "Cancelar",
    demoSent: "Correo preparado para {n} destinatario(s) — registrado en modo demo.",
    missingFields: "Escribe asunto y mensaje.",
    noRecipients: "No hay destinatarios con correo registrado.",
    missingEmails: "{n} sin correo en su perfil",
    logTitle: "Correos registrados",
    logEmpty: "Aún no se han preparado correos.",
    defaultSubjectGroup: "STM · Sesión inicial de tu grupo",
    defaultSubjectIndividual: "STM · Información de tu programa",
    defaultBody:
      "Hola,\n\nTe compartimos los datos de la sesión inicial de tu programa Share The Med. Te pedimos conectarte cinco minutos antes.\n\nCualquier duda, responde a este correo.\n\nDirección Académica · Share The Med",
    template: "Plantilla",
    templateLang: "Idioma del correo",
    preview: "Vista previa",
    variablesHint: "Variables disponibles: {{nombre}}, {{grupo}}, {{fecha}}, {{enlace}}",
  },
  template: {
    heading: "Editor de plantilla bilingüe",
    lead: "Actualiza el texto del correo en español e inglés sin tocar código. Usa las variables para personalizar cada envío.",
    nameEs: "Nombre (ES)",
    nameEn: "Nombre (EN)",
    subjectEs: "Asunto (ES)",
    subjectEn: "Asunto (EN)",
    bodyEs: "Mensaje (ES)",
    bodyEn: "Mensaje (EN)",
    buttonEs: "Texto del botón (ES)",
    buttonEn: "Texto del botón (EN)",
    signatureEs: "Firma (ES)",
    signatureEn: "Firma (EN)",
    image: "Imagen de encabezado (URL)",
    imageHint: "Se muestra arriba del mensaje en el correo.",
    save: "Guardar plantilla",
    saved: "Plantilla actualizada.",
    preview: "Vista previa del correo",
    previewLang: "Idioma de la vista previa",
    variables: "Variables",
    variablesHint:
      "{{nombre}} nombre del participante · {{grupo}} nombre del grupo · {{fecha}} fecha de inicio · {{enlace}} enlace de la sesión",
    empty: "Aún no hay plantilla configurada.",
  },
};


const en: AdminContent = {
  title: "Academic Direction",
  lead: "Review applications, enable payments and organize program groups.",
  denied: "This section is restricted to STM Academic Direction.",
  back: "Go to my portal",
  tabs: {
    applications: "Applications",
    groups: "Groups",
    templates: "Email template",
    coupons: "Coupons",
    publications: "Publications",
  },
  publications: {
    heading: "New publication",
    editHeading: "Edit publication",
    lead: "Register program publications: journal, year, indexing, quartile, authors, DOI and external link.",
    title: "Title",
    titlePlaceholder: "Article title",
    journal: "Journal name",
    journalPlaceholder: "e.g. Cureus",
    year: "Year",
    indexed: "Indexed journal",
    quartile: "Belongs to a Q quartile",
    description: "Description",
    descriptionPlaceholder: "Short summary of the article…",
    authors: "Authors and countries",
    addAuthor: "Add author",
    authorName: "Author name",
    authorCountry: "Country",
    noAuthors: "No authors registered.",
    doi: "DOI",
    doiPlaceholder: "10.xxxx/...",
    link: "External link",
    linkPlaceholder: "https://...",
    openLink: "Open link",
    create: "Create publication",
    saveChanges: "Save changes",
    cancel: "Cancel",
    edit: "Edit",
    delete: "Delete",
    created: "Publication created.",
    updated: "Publication updated.",
    deleted: "Publication deleted.",
    confirmDelete: "Delete this publication?",
    empty: "No publications registered yet.",
    invalid: "Enter the title and the journal name.",
    invalidYear: "Enter a valid year.",
    yes: "Yes",
    no: "No",
  },
  coupons: {
    heading: "Discount coupons",
    lead: "Create coupons limited by date range and number of uses, and review who redeemed them.",
    code: "Coupon code",
    codePlaceholder: "e.g. STM2026",
    description: "Internal description",
    descriptionPlaceholder: "Campaign, alliance, scholarship…",
    type: "Discount type",
    typePercent: "Percentage",
    typeAmount: "Fixed amount",
    percentOff: "Percentage off (%)",
    amountOff: "Amount off",
    currency: "Currency",
    pathway: "Applies to pathway",
    anyPathway: "Any pathway",
    startsAt: "Valid from",
    expiresAt: "Valid until",
    maxRedemptions: "Maximum uses",
    maxRedemptionsHint: "Leave empty for unlimited uses.",
    unlimited: "Unlimited",
    create: "Create coupon",
    created: "Coupon created.",
    empty: "No coupons created yet.",
    active: "Active",
    inactive: "Inactive",
    activate: "Activate",
    deactivate: "Deactivate",
    delete: "Delete",
    deleted: "Coupon deleted.",
    confirmDelete: "Delete this coupon and its redemption history?",
    usage: "Uses",
    window: "Valid",
    noWindow: "No date limit",
    expired: "Expired",
    scheduled: "Scheduled",
    redemptions: "Redemptions",
    redemptionsEmpty: "No one has redeemed this coupon yet.",
    viewRedemptions: "View redemptions",
    hideRedemptions: "Hide redemptions",
    participant: "Participant",
    discountApplied: "Discount applied",
    invalidCode: "Use 3 to 40 characters: letters, numbers, dashes.",
    invalidDiscount: "Enter a valid discount value.",
  },

  apps: {
    heading: "Received applications",
    empty: "No applications yet.",
    filterAll: "All",
    status: "Application status",
    reviewerNotes: "Notes for the participant",
    reviewerNotesPlaceholder: "Feedback visible to the applicant…",
    saveStatus: "Save status",
    saved: "Application updated.",
    history: "History",
    historyEmpty: "No activity recorded.",
    addComment: "Internal comment / follow-up",
    commentPlaceholder: "Write a comment for the history…",
    sendComment: "Add comment",
    commentSaved: "Comment added.",
    group: "Assigned group",
    noGroup: "No group",
    assign: "Assign",
    assigned: "Assignment updated.",
    unassign: "Remove from group",
    fee: "Participation fee",
    acceptOnlyGroup: "Save the status as accepted or paid to assign this application to a group.",
    groupFull: "This group has reached its maximum capacity.",
    noGroupForPathway: "No active groups for this pathway yet. Create one in the Groups tab.",
  },
  groups: {
    heading: "Program groups",
    lead: "Create groups per pathway and assign accepted participants.",
    name: "Group name",
    namePlaceholder: "e.g. Basic Group Fall 2026",
    pathway: "Pathway",
    startsOn: "Start date",
    capacity: "Capacity",
    notes: "Notes",
    notesPlaceholder: "Assigned mentor, session schedule…",
    create: "Create group",
    created: "Group created.",
    empty: "No groups created yet.",
    members: "Members",
    seats: "seats",
    archive: "Archive",
    activate: "Reactivate",
    active: "Active",
    archived: "Archived",
  },
  email: {
    title: "Program email",
    openGroup: "Email the group",
    openIndividual: "Send email",
    demoBadge: "Demo",
    demoNote:
      "Demo mode: the email is logged in the platform but not delivered to participants yet. It goes live once the STM sending domain is configured.",
    to: "To",
    subject: "Subject",
    body: "Message",
    sessionLink: "Session link",
    send: "Log send (demo)",
    cancel: "Cancel",
    demoSent: "Email prepared for {n} recipient(s) — logged in demo mode.",
    missingFields: "Add a subject and a message.",
    noRecipients: "No recipients with a registered email.",
    missingEmails: "{n} without email on file",
    logTitle: "Logged emails",
    logEmpty: "No emails prepared yet.",
    defaultSubjectGroup: "STM · Your group's kick-off session",
    defaultSubjectIndividual: "STM · Your program details",
    defaultBody:
      "Hello,\n\nHere are the details for the kick-off session of your Share The Med program. Please join five minutes early.\n\nIf you have any questions, just reply to this email.\n\nAcademic Direction · Share The Med",
    template: "Template",
    templateLang: "Email language",
    preview: "Preview",
    variablesHint: "Available variables: {{nombre}}, {{grupo}}, {{fecha}}, {{enlace}}",
  },
  template: {
    heading: "Bilingual template editor",
    lead: "Update the email copy in Spanish and English without touching code. Use variables to personalize each send.",
    nameEs: "Name (ES)",
    nameEn: "Name (EN)",
    subjectEs: "Subject (ES)",
    subjectEn: "Subject (EN)",
    bodyEs: "Message (ES)",
    bodyEn: "Message (EN)",
    buttonEs: "Button label (ES)",
    buttonEn: "Button label (EN)",
    signatureEs: "Signature (ES)",
    signatureEn: "Signature (EN)",
    image: "Header image (URL)",
    imageHint: "Shown above the message inside the email.",
    save: "Save template",
    saved: "Template updated.",
    preview: "Email preview",
    previewLang: "Preview language",
    variables: "Variables",
    variablesHint:
      "{{nombre}} participant name · {{grupo}} group name · {{fecha}} start date · {{enlace}} session link",
    empty: "No template configured yet.",
  },
};


export const adminContent: Record<Lang, AdminContent> = { es, en };
